import { render, staticRenderFns } from "./editFreightDialog.vue?vue&type=template&id=006c5454&scoped=true"
import script from "./editFreightDialog.vue?vue&type=script&lang=js"
export * from "./editFreightDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006c5454",
  null
  
)

export default component.exports